import React, { useEffect } from "react";

import * as Sentry from "@sentry/react";
import { Elements as StripeElements } from "@stripe/react-stripe-js";
import type { StripeElementsOptions } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import Config from "@app/config";

const stripePromise = loadStripe(Config.stripe.publishableKey);

// Wrap the stripe promise so we can expose on the window object without exposing the Stripe object
window.READ_STRIPE_ERROR_PROMISE = new Promise((resolve, reject) => {
  stripePromise.then(() => resolve(true)).catch((error) => reject(error));
});

const STRIPE_ELEMENT_APPEARANCE: StripeElementsOptions["appearance"] = {
  theme: "stripe",
  variables: {
    colorPrimary: "#4C47CC",
    fontFamily: "Work Sans, sans-serif",
    colorTextPlaceholder: "#C1C1C1",
    borderRadius: "6px",
    colorText: "#656565",
  },
};

interface StripeFormProps {
  children: React.ReactNode;
  options?: StripeElementsOptions | null;
  requireClientSecret?: boolean;
}

const StripeForm = ({
  children,
  options = {},
  requireClientSecret = false,
}: StripeFormProps) => {
  useEffect(() => {
    stripePromise.catch((error) => {
      Sentry.captureException(
        new Error(`Caught stripe load failure: ${error.message}`)
      );
    });
  }, []);

  if (requireClientSecret && !options?.clientSecret) return null;

  return (
    <StripeElements
      stripe={stripePromise}
      options={{ ...(options ?? {}), appearance: STRIPE_ELEMENT_APPEARANCE }}
    >
      {children}
    </StripeElements>
  );
};

export default StripeForm;
